import {Injectable} from '@angular/core';
import {AResourceService} from "./a-resource.service";
import {PricelistModel} from "../../models/resources/pricelist.model";
import {LanguageService} from "./language.service";
import {UrlParamModel} from "../../models/url-param.model";

@Injectable({
  providedIn: 'root',
})
export class PricelistService extends AResourceService<PricelistModel> {
  constructor(private languageService: LanguageService) {
    super('/pricelists', false);
  }

  protected override getDefaultListParams(): UrlParamModel[] {
    const code = this.languageService.activeLanguage()?.code;
    if (!code) {
      return [];
    }
    return [{key: 'lang', value: code}];
  }
}
